import { spyLaunchSettingsConvertToStateValue } from 'shared/lib/spyLaunchSettingsConvertToStateValue'
import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContextSpyLaunchSettings as selectContextSpyLaunchSettingsInState, 
    setContextSpyLaunchSettings as setContextSpyLaunchSettingsInState
} from 'store/applicationSlice'
import { spyLaunchSettingsConvertFromStateValue } from 'shared/lib/spyLaunchSettingsConvertFromStateValue'

export const useContextSpyLaunchSettings = () => {
    const dispatch = useAppDispatch()
    const selectContextSpyLaunchSettingsFromState = useAppSelector(selectContextSpyLaunchSettingsInState) 
    const selectContextSpyLaunchSettings = spyLaunchSettingsConvertFromStateValue(selectContextSpyLaunchSettingsFromState)

    const setContextSpyLaunchSettings = (contextSpyLaunchSettings: any) => {
        const convertedForState = spyLaunchSettingsConvertToStateValue(contextSpyLaunchSettings)
        dispatch(setContextSpyLaunchSettingsInState(convertedForState))
    }
  
    return {
        selectContextSpyLaunchSettings,
        setContextSpyLaunchSettings
    }
}